import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=775fe007"
import script from "./Properties.vue?vue&type=script&lang=ts"
export * from "./Properties.vue?vue&type=script&lang=ts"
import style0 from "./Properties.vue?vue&type=style&index=0&id=775fe007&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports